import * as React from 'react';
import * as Styled from './backToTopScrollStyle';
import IconArrowDown from '../../images/icon-arrow-down.png';

const BackToTopScroll = () => {
  const [scrollPosition, setScrollPosition] = React.useState(0);
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  React.useLayoutEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <>
      {scrollPosition > 0 && (
        <Styled.MainContainer>
          <Styled.ScrollAnchor href="#top">
            <Styled.ScrollImage src={IconArrowDown} alt="Return To Top" />
          </Styled.ScrollAnchor>
        </Styled.MainContainer>
      )}
    </>
  );
};

export default BackToTopScroll;
